export const raceTypeNames = {
    F: 'Flat Turf and NHF',
    X: 'All Weather',
    H: 'Hurdle',
    C: 'Chase',
};

export const raceTypes = Object.keys(raceTypeNames);

export const initEmptyNotes = existingNotes => (
    raceTypes.reduce((acc, type) => ({
        ...acc,
        [type]: {
            raceType: type,
            ratingFlag: '',
            rating: '',
            note: '',
            isExists: (existingNotes && existingNotes[type].isExists) || false,
        },
    }), {})
);

export const errorMessageText =
    `Something's gone wrong 
     and your changes could not be saved. 
     Press save to try again.`;

export const getAjaxUrl = horseUid => `horse/ugc/${horseUid}`;

export const validateInput = (name, value) => {
    let rating = value;
    if (name === 'rating') {
        rating = value.replace(/[^0-9]/g, '');
        rating = (+rating > 500) ? 500 : rating;
    }

    return rating;
};




// WEBPACK FOOTER //
// ./src/js/horse/notes/helpers.js